import React from 'react';
import ShareIcon from 'react-icons/lib/fa/share-alt';
import {getHrefFb, getHrefTw, getHrefGp} from '../../utils';

import * as AppActions from '../../modules/App/AppState';

import './header.styl';
import smIcons from '../../../public/images/social.png';


const Header = props => {
  const onFaqClick = () => {
    props.dispatch(AppActions.toggleFaq());
  }

  const onEmbedClick = () => {
    props.dispatch(AppActions.toggleEmbed());
  }
  const bgImage = {backgroundImage: 'url(' + smIcons + ')'};


  return (
    <div className="ifdw-header">
      <div className="ifdw-header--button" onClick={onFaqClick}><span className="icon">{'?'}</span>FAQ</div>
      <div className="ifdw-header--button" onClick={onEmbedClick}><span className="icon icon-embed">{'❮ ❯'}</span>EMBED</div>
      <div className="ifdw-header--button ifdw-header--share-button">
        <span className="icon"><ShareIcon /></span>SHARE
        <div className="ifdw-header--rollover">
            <a className="share-link share-facebook" style={bgImage} target="_blank" href={getHrefFb()}></a>
            <a className="share-link share-google" style={bgImage} target="_blank" href={getHrefGp()}></a>
            <a className="share-link share-twitter" style={bgImage} target="_blank" href={getHrefTw()}></a>
        </div>
      </div>
    </div>
  )
};

export default Header;



/** WEBPACK FOOTER **
 ** ./src/components/Header/index.js
 **/